/**
 * «¿Qué hay que cambiar?» — al mandar una pieza a Cliente Cambios, EC Cambios o QC Cambios hay que dejar escrito el motivo.
 *
 * Medido: el 86 % de los «Cliente Cambios» los pasa un EC y ninguno dejaba escrito qué había pedido el cliente: el diseñador se enteraba por un aviso sin
 * contenido. `pedirMotivo` abre el cuadro de MotivoCambioHost (montado en el Layout) y devuelve el texto, o null si la persona cancela. Lo usa
 * api.patchTarea, así que cubre al Kanban, la tabla de Tareas y el panel de la tarea sin tocar cada uno.
 */
export const ESTADOS_CAMBIOS = new Set(["Cliente Cambios", "EC Cambios", "QC Cambios"]);

let hayHost = false;
export const registrarHost = (v) => { hayHost = !!v; };

/** Devuelve el motivo escrito, "" si no hay dónde preguntar (no se bloquea el cambio), o null si la persona cancela. */
export function pedirMotivo({ estado, tareaId } = {}) {
  if (!hayHost || typeof window === "undefined") return Promise.resolve("");
  return new Promise((resolver) => { window.dispatchEvent(new CustomEvent("crew-pedir-motivo", { detail: { estado, tareaId, resolver } })); });
}
